import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
  EditButton,
  DeleteButton,
  Show,
  SimpleShowLayout,
  ShowButton,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';
import { ImportButton } from "react-admin-import-csv";

const ListActions = (props) => (
  <TopToolbar>
    <CreateButton {...props} />
    <ExportButton {...props} />
    <ImportButton {...{
      resource: "courses",
      parseConfig: {
        skipEmptyLines: true,
      }
    }}/>
  </TopToolbar>
);

export const CourseList = () => (
  <List actions={<ListActions />}>
    <Datagrid>
      <TextField source="name" />
      <TextField source="location" />
      <TextField source="description" />
      <TextField source="numberOfHoles" />
      <TextField source="latitude" />
      <TextField source="longitude" />
      <TextField source="imageUrl" />
      <ShowButton />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const CourseShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="location" />
      <TextField source="description" />
      <TextField source="numberOfHoles" />
      <TextField source="latitude" />
      <TextField source="longitude" />
      <TextField source="imageUrl" />
    </SimpleShowLayout>
  </Show>
);

export const CourseEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="location" validate={[required()]} fullWidth />
      <TextInput
        source="description"
        validate={[required()]}
        multiline
        rows={4}
        fullWidth
      />
      <NumberInput
        source="numberOfHoles"
        validate={[required()]}
        min={1}
        max={36}
      />
      <NumberInput
        source="latitude"
        validate={[required()]}
        step={0.000001}
      />
      <NumberInput
        source="longitude"
        validate={[required()]}
        step={0.000001}
      />
      <TextInput 
        source="imageUrl" 
        validate={[required()]} 
        fullWidth
        helperText="Enter the URL of the course image"
      />
    </SimpleForm>
  </Edit>
);

export const CourseCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="location" validate={[required()]} fullWidth />
      <TextInput
        source="description"
        validate={[required()]}
        multiline
        rows={4}
        fullWidth
      />
      <NumberInput
        source="numberOfHoles"
        validate={[required()]}
        min={1}
        max={36}
      />
      <NumberInput
        source="latitude"
        validate={[required()]}
        step={0.000001}
      />
      <NumberInput
        source="longitude"
        validate={[required()]}
        step={0.000001}
      />
      <TextInput 
        source="imageUrl" 
        validate={[required()]} 
        fullWidth
        helperText="Enter the URL of the course image"
      />
    </SimpleForm>
  </Create>
); 